export default __webpack_public_path__ + "static/media/facebook.c2eff7f6.svg";